import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 p-2" }
const _hoisted_2 = { class: "col-12 p-0 font-light" }
const _hoisted_3 = { class: "m-0 text-justify word-wrap-break overflow-hidden text-overflow-ellipsis white-space-nowrap" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" - ")

import { Comment } from '@/models/comment';


export default /*#__PURE__*/_defineComponent({
  props: {
    comment: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push(`/post/${__props.comment.post.uuid}`)), ["stop"])),
          class: "cursor-hover underline-hover"
        }, _toDisplayString(__props.comment.content), 1),
        _hoisted_4,
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {_ctx.$router.push(`/post/${__props.comment.post.uuid}`);}, ["stop"])),
          class: "cursor-hover"
        }, _toDisplayString(__props.comment.post.title ? __props.comment.post.title : __props.comment.post.url), 1)
      ])
    ])
  ]))
}
}

})